module.exports = "<sc-frame-view class=\"maximize\" src=\"$ctrl.src\" maximize=\"$ctrl.maximize\" min-height=\"$ctrl.minHeight\" on-frame-create=\"$ctrl.onFrameCreate(frame)\" on-frame-load=\"$ctrl.onFrameLoad(frame)\"></sc-frame-view>"


//////////////////
// WEBPACK FOOTER
// ./src/view/report-frame-view.component.html
// module id = 392
// module chunks = 0